// src/components/dashboard/dashboard.styled.ts
import styled from 'styled-components';

export const ChartContainer = styled.div`
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--text);
  padding: 16px;
  border-radius: 12px;
  box-shadow: var(--shadow);
  margin-bottom: 24px;
`;

export const ChartTitle = styled.h2`
  font-size: 18px;
  margin-bottom: 12px;
  color: var(--text);
`;


export const ChartWrapper = styled.div`
  width: 100%;
  height: 300px;
`;
